import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  left: 100%;
  top: 0;
  width: 250px;
  background-color: #f0f0fc;
  height: 100%;
  margin-left: -10px;
  padding: 35px 10px 0 20px;
  border-radius: 6px;

  @media (max-width: 768px) {
    position: relative;
    left: 0%;
    width: 100%;
    margin-left: 0;
    padding: 33px 10px 0 55px;
  }
`;

export const Header = styled.div`
  @media (max-width: 768px) {
    ${'' /* display: flex; */}
  }
`;

export const Title = styled.p`
  color: #222939;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 0;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileTitle = styled.div`
  display: none;
  margin-left: -45px;
  color: #222939;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    margin-bottom: -10px;
  }
`;

export const PlanName = styled.p`
  color: #6e56d5;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    color: #222939;
    font-size: 18px;
    letter-spacing: 0;
    margin-bottom: 20px;
  }
`;

export const Features = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Feature = styled.div`
  display: flex;
  margin-bottom: 15px;

  img {
    margin: 4px 12px 0 0;
    height: 12px;
  }
`;

export const FeatureText = styled.p`
  color: #484663;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0;
  margin-bottom: 0;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/upgradeConfirmationModal/OrderDetailsStyle.js